var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6,24.6L14.3,7.9V6.1h10.1l-3-3l3-3H13.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0h-0.6v0.8l0,0l0,0 c0,2.3,0,3.5,0,4.1v2.8L2.3,24.6c-0.4,0.7-0.5,1.5,0,2.3s1.1,1.1,2,1.1h19.6c0.8,0,1.5-0.4,1.9-1.2C26.1,26.1,26.1,25.3,25.6,24.6z  M14.3,1.7h6.3l-1.4,1.4l1.4,1.5h-6.4L14.3,1.7L14.3,1.7z M13.5,9.5l3.7,5.5c-0.3,0.2-0.6,0.5-0.9,0.7s-0.7-0.1-0.9-0.4 c-0.5-0.7-1.2-0.8-1.6-0.8c-0.6,0-1.1,0.2-1.5,0.6l-0.1,0.1c-0.1,0.1-0.5,0.6-0.7,0.5c-0.5-0.1-1-0.5-1.4-0.8L13.5,9.5z M24.4,26.1 c-0.1,0.1-0.2,0.3-0.5,0.3H4.2c-0.4,0-0.5-0.2-0.6-0.3c-0.1-0.1-0.2-0.4,0-0.7l5.6-9.1c0.5,0.4,1.1,0.8,1.9,1c1,0.2,1.8-0.6,2.2-1 l0.1-0.1c0.1-0.1,0.2-0.2,0.4-0.1c0.1,0,0.3,0.1,0.4,0.3c0.6,0.7,1.3,1,1.9,1c0.4,0,0.8-0.1,1.2-0.4c0.3-0.2,0.6-0.4,0.8-0.6 l6.2,9.2C24.5,25.8,24.4,26,24.4,26.1z M9.9,19.4c-0.3-0.2-0.6-0.1-0.8,0.2l-2.5,4.3c-0.2,0.3-0.1,0.6,0.2,0.8 c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.5-0.3l2.5-4.3C10.3,19.9,10.2,19.6,9.9,19.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.b8715554.svg";
export { ForwardRef as ReactComponent };